import { gql } from '@apollo/client';

export const getAllThreadItems = gql`query getAllThreadItems($bookingId: Int!, $offset: Int) {
    getAllThreadItems(bookingId: $bookingId, offset: $offset) {
        threadItems {
          id
          threadId
          isRead
          authorId
          userId
          message
          createdAt
          updatedAt
        }
        userDetails {
          id
          email
          profile {
            firstName
            picture
          }
        }
        partnerDetails {
          id
          email
          profile {
            firstName
            picture
          }
        }
        count
      }
  }`

export const createThread = gql`
  mutation createThread($bookingId: Int!, $message: String!) {
    createThread(bookingId: $bookingId, message: $message) {
    	status
    	errorMessage
    }
  }`;

export const readThread = gql`
  mutation readThread($bookingId: Int!) {
	  readThread(bookingId: $bookingId) {
		  status
		  errorMessage
	}
}`;